export default "__VITE_ASSET__CJFA0QRB__"